import { render, staticRenderFns } from "./setType1Template.vue?vue&type=template&id=3f0bbfdd&scoped=true"
import script from "./setType1Template.vue?vue&type=script&lang=js"
export * from "./setType1Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0bbfdd",
  null
  
)

export default component.exports